import { FeatureNameEnum } from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useFeature } from 'src/features/featureFlags/useFeatureFlags'
import { toggleEditable } from 'src/state/ducks/templates/editTemplate/actions'
import { RootState } from 'src/state/store'
import {
  calculateSwitchChecked,
  canControlEditability,
} from './editabilitySwitchLogic'
import { OptionToggleSwitch } from './OptionToggleSwitch'

const EditableSwitch: FC = () => {
  const dispatch = useDispatch()
  const isEditable = useSelector(
    (state: RootState) => state.templatesState.editTemplate.isEditable,
    shallowEqual,
  )
  const templateApprovalFlowId = useSelector(
    (state: RootState) => state.templatesState.editTemplate.approvalFlowId,
  )

  // Feature Flag で承認フローなしの編集可否制御が許可されているかチェック
  const { canUse } = useFeature(
    FeatureNameEnum.EDITABILITY_WITHOUT_APPROVAL_FLOW,
  )
  const canUseFeature = canUse === 'yes'

  const canControl = canControlEditability(
    templateApprovalFlowId,
    canUseFeature,
  )
  const isChecked = calculateSwitchChecked(isEditable, canControl)

  return (
    <OptionToggleSwitch
      isChecked={isChecked}
      onChange={checked => dispatch(toggleEditable(checked))}
      label="レポート提出後の編集可"
      isDisabled={!canControl}
    />
  )
}

export default EditableSwitch
